import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--down",
  "use": "icon-arrow--down-usage",
  "viewBox": "0 0 6 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 5\" id=\"icon-arrow--down\"><path d=\"M3.217 4.625a.25.25 0 0 1-.434 0L.618.875A.25.25 0 0 1 .835.5h4.33a.25.25 0 0 1 .217.375l-2.165 3.75Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol